export const AUCTION_MODULE_PDP = 'auctionModuleDlosPDP';
